import { Plugins, Context } from '@leverege/plugin';
// import { ItemModel, ItemTypeModel } from '@leverege/ui-attributes'
import { ItemModel, ItemTypeModel } from '@leverege/ui-attributes';
import MoltenUtil from "../MoltenUtil.js";
/**
 * This will create an ItemTypeModel, run it through all `ItemTypeModelConfigurer`
 * plugins that match against the given cxt object, and return it.
 * The ItemTypeModelConfigure plugins should implement a `configure( itemTypeModel, objectType, cxt )`
 * function that returns a configured ItemTypeModel. 
 * @param {String|Array<String>} objectType 
 * @param {Object} cxt the match context used to find configurers
 * @returns ItemModel 
 */
const createItemTypeModel = (objectType, cxt) => {
  let itm = ItemTypeModel.create(objectType);
  const context = cxt || {};
  const cfgs = MoltenUtil.sortedPlugins('ItemTypeModelConfigurer', Context.createMatch(context));
  cfgs.forEach(c => {
    try {
      const nItm = c.configure(itm, objectType, context);
      itm = nItm || itm;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  });
  return itm;
};

/**
 * This will look at all DataSources to find sources that
 * manage the objectType and create an ItemModel with each
 * type added to it. 
 * @param {String|Array<String>} objectType 
 * @returns ItemModel 
 */
const create = (objectType, cxt) => {
  let mdl = ItemModel.create();
  const dataSources = Plugins.get('DataSource');
  const isArray = Array.isArray(objectType);
  for (let n = 0; n < dataSources.length; n++) {
    const ds = dataSources[n];
    const isType = isArray ? objectType.includes(ds.type) : ds.type === objectType;
    if (isType && ItemModel.getType(mdl, ds.type) == null) {
      const itm = createItemTypeModel(ds.type, cxt);
      mdl = ItemModel.setType(mdl, ds.type, itm);
    }
  }
  return mdl;
};
export default {
  create,
  createItemTypeModel
};